import './App.css'
import React, {ReactNode, useEffect, useContext, createContext, useState} from "react"
import { useStore } from "./state/state";
import "./layout.css";
import Modal from "./components/modal.tsx";
import Navigation from "./components/navigation.tsx";
import ViewCurrentState from "./views/view_current_state.tsx";
import { STEPS } from "./state/types.ts";
import ViewBase1 from "./views/view_base_1.tsx";
import ViewBase2 from "./views/view_base_2.tsx";
import ViewBase3 from "./views/view_base_3.tsx";
import ViewFutureState from "./views/view_future_state.tsx";
import ViewCalculation from "./views/view_calculation.tsx";
import { ConfigContext } from './config_context.ts';

export default function App(props: {config: object, children?: ReactNode | Array<ReactNode>}) {
   // @ts-ignore:TS2339
  const [config_override, set_config_override] = useState<Partial<Config>>(null);
  const api_login = useStore((state) => state.api_login);
  const api_basic_data = useStore((state)=>state.api_basic_data);
  const api_financial_plan_dummy = useStore((state)=>state.api_financial_plan_dummy);
  const api_recalculate = useStore((state) => state.api_recalculate);

  const config = {...props.config, ...config_override};

  useEffect(()=>{
    const params = new URLSearchParams(document.location.search);
    const uidParam = params.get("uid");
    const metaUid = document.querySelector('meta[name="uid"]')?.getAttribute('content');
    const uid = uidParam !== null && uidParam !== "" ? uidParam : metaUid;
    set_config_override({
      uid,
    });
    const base_url = config.base_asset_url.substring(0, config.base_asset_url.length - 1);
    api_login(base_url);
  },[]);
  

  return (
    <>
      <ConfigContext value={config}>
      <ModalContainer/>
      {/* <DebugButton/> */}
      <NavigationAndViews validation={[
        ()=> useStore.getState().gebaeude_typ !== undefined,
        ()=> {
          const state = useStore.getState();
          return (state.postleitzahl !== undefined &&
                  state.vollgeschosse !== undefined && state.vollgeschosse != "" &&
                  state.wohneinheiten !== undefined && state.wohneinheiten != "" &&
                  state.baujahr !== undefined &&
                  state.wohnflaeche !== undefined && state.wohnflaeche != "");
        },
        ()=> {
          const state = useStore.getState();
          switch (state.heizung) {
                case "heating_system_current_0":
                  return (state.oelverbrauch !== undefined && state.oelverbrauch != 0 &&
                  state.stromverbrauch !== undefined && state.stromverbrauch != "");
                case "heating_system_current_1":
                  return (state.gasverbrauch !== undefined && state.stromverbrauch !== undefined && state.stromverbrauch != "");
                case "heating_system_current_2":
                  return (state.holzverbrauch !== undefined && state.holzverbrauch != 0 &&
                  state.stromverbrauch !== undefined && state.stromverbrauch != "");
                case "heating_system_current_3":
                  return (state.stromverbrauchwaermepumpe !== undefined && state.stromverbrauchwaermepumpe != "" &&
                  state.stromverbrauch !== undefined && state.stromverbrauch != "");
                case "heating_system_current_4":
                  return (state.stromverbrauchwaermepumpe !== undefined && state.stromverbrauchwaermepumpe != "" &&
                  state.stromverbrauch !== undefined && state.stromverbrauch != "");
                default:
                  return state.stromverbrauch !== undefined && state.stromverbrauch != "";
            }
        },
        ()=> true,
        ()=> true,
        ()=> true,
      ]}
      transitions={{
        "2 -> 3": async ()=>{
          await api_basic_data();
          await api_financial_plan_dummy();
        },
        "3 -> 4": async ()=>{
          await api_recalculate();
        },
        "4 -> 5": async ()=>{
          await api_recalculate();
        },
        "5 -> 6": async ()=>{
          await api_recalculate();
        }
      }}
      >
        {props.children !== undefined && 
        props.children !== null ? 
        props.children: 
        [
         <ViewBase1/>,
         <ViewBase2/>,
         <ViewBase3/>,
         <ViewCurrentState/>,
         <ViewFutureState/>,
         <ViewCalculation/>,
        ]}
      </NavigationAndViews>
      </ConfigContext>
    </>
  );
}
function DebugButton() {
  const set_property = useStore((state) => state.set_property);

  return <div 
  aria-hidden
  style={{
    position: "fixed",
    width: "4px",
    height: "4px",
    right: "0px",
    top: "0px",
    backgroundColor: "rgb(234, 234, 234)",
    zIndex: 9999999,
  }} onClick={()=>{
            set_property('gebaeude_typ', 'sfh');
            set_property("postleitzahl", 61267);
            set_property("vollgeschosse", 2);
            set_property("wohneinheiten", 2) ;
            set_property("baujahr_base", 1987);
            set_property("baujahr", 1987);
            set_property("wohnflaeche", 120);
            set_property("heizung","heating_system_current_0");
            set_property("oelverbrauch", 1200);
            set_property("stromverbrauch", 1200);
            set_property("gasverbrauch", 1200) ;
            set_property("stromverbrauch", 1200) ;
            set_property("stromverbrauchwaermepumpe", 1200);
        }}></div>;
}

function NavigationAndViews(props:{children: ReactNode, validation: Array<()=>boolean>, transitions: Record<string, ()=>void>}){
    const is_modal_active = useStore((state) => state.is_modal_active());
  const last_step_number = useStore((state) => state.last_step_number);
   const current_step_number = useStore((state) => state.current_step_number);
   useEffect(()=>{
    const t = (last_step_number + 1) + " -> " + (current_step_number + 1);
    //console.log(t)
    const transition = props.transitions[t];
    if(transition !== undefined){
      transition();
    }
   },[current_step_number]);
    return  <div 
      inert={is_modal_active}
      className="navigation-and-views"
      >
        <Navigation steps={STEPS} validation={props.validation[current_step_number]} />
        <div className="views">
            {Array.isArray(props.children) && props.children.length > 0 && props.children[current_step_number]}
        </div>
    </div>;  
}    

function ModalContainer(){
  const modal_counter = useStore((state) => state.modal_counter);
  const is_modal_active = useStore((state) => state.is_modal_active());
  const active_modal = useStore((state) => state.active_modal);
  const pop_modal = useStore((state) => state.pop_modal);
    
  if (!is_modal_active){
    return <></>;
  }

  return <Modal key={modal_counter} on_click_background={()=>{
    if(active_modal().close_on_click_background){
      pop_modal();
    }
  }}>{active_modal().modal()}</Modal>
}    